import { memo, useEffect, useMemo, useState } from 'react';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { getUserInfo } from '@/apis';
import { UserRights } from '@/types';

interface IProps {
    userRights: UserRights;
    projectName: string;
    onClose: () => void;
}

const Header = ({ userRights, projectName, onClose }: IProps) => {
    const [basicInfo, setBasicInfo] = useState({
        headImgUrl: 'https://simg01.gaodunwangxiao.com/v/Uploads/avatar/default.jpg',
        nickName: '',
    });

    const teacherAskNum = useMemo(() => {
        const { teacherAskNum } = userRights;
        if (teacherAskNum > 10000000) return '无限';
        if (teacherAskNum > 1000000) return `${Math.floor(teacherAskNum / 10000)}w`;
        return teacherAskNum;
    }, [userRights]);

    const manualCorrectNum = useMemo(() => {
        const { manualCorrectNum } = userRights;
        if (manualCorrectNum > 10000000) return '无限';
        if (manualCorrectNum > 1000000) return `${Math.floor(manualCorrectNum / 10000)}w`;
        return manualCorrectNum;
    }, [userRights]);

    const initUerInfo = async () => {
        const { data } = await getUserInfo();
        data && setBasicInfo({ ...data, headImgUrl: data.headImgUrl || basicInfo.headImgUrl });
    };

    useEffect(() => {
        initUerInfo();
    }, []);

    return (
        <>
            <div className="rights-title-box">
                <div>
                    权益
                    <div className="project-item">{projectName}</div>
                </div>
                <CloseOutlined onClick={onClose} />
            </div>
            <div className="rights-user-info">
                <div className="user-info">
                    <img className="user-awater" src={basicInfo.headImgUrl} />
                    <span className="user-name">{basicInfo.nickName}</span>
                </div>
                <div className="luca-info">
                    <span>
                        luca答疑 <span className="luca-info-weight">{userRights.lucaAskNum}</span>次
                    </span>
                    <span>
                        名师答疑
                        {userRights.subjects?.length > 0 && (
                            <span className="subject-list-box-hover">
                                <div className="subject-list-box-hover-container">
                                    <div className="subject-list-box-container">
                                        <div className="subject-list-box-scroll-container">
                                            <div className="subject-list-box">
                                                <div className="tip-title">仅限于以下科目使用</div>
                                                <div className="project-item">{projectName}</div>
                                                <div className="list-box">
                                                    {userRights.subjects?.map(item => (
                                                        <div key={item.id} className="subject-item">
                                                            {item.name}
                                                        </div>
                                                    ))}
                                                    {userRights.subjects?.length % 2 === 1 && <div className="subject-item" />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <QuestionCircleOutlined />
                            </span>
                        )}
                        <span className="luca-info-weight">{teacherAskNum}</span>次
                    </span>
                    {userRights.aiCorrectAuth && (
                        <span>
                            智能批改
                            {userRights.aiCorrectSubjects?.length > 0 && (
                                <span className="subject-list-box-hover">
                                    <div className="subject-list-box-hover-container">
                                        <div className="subject-list-box-container">
                                            <div className="subject-list-box-scroll-container">
                                                <div className="subject-list-box">
                                                    <div className="tip-title">仅限于以下科目使用</div>
                                                    <div className="project-item">{projectName}</div>
                                                    <div className="list-box">
                                                        {userRights.aiCorrectSubjects?.map(item => (
                                                            <div key={item.id} className="subject-item">
                                                                {item.name}
                                                            </div>
                                                        ))}
                                                        {userRights.aiCorrectSubjects?.length % 2 === 1 && <div className="subject-item" />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <QuestionCircleOutlined />
                                </span>
                            )}
                            <span className="luca-info-weight">{userRights.aiCorrectNum}</span>次
                        </span>
                    )}
                    {userRights.manualCorrectAuth && (
                        <span>
                            人工批改
                            {userRights.manualCorrectSubjects?.length > 0 && (
                                <span className="subject-list-box-hover">
                                    <div className="subject-list-box-hover-container">
                                        <div className="subject-list-box-container">
                                            <div className="subject-list-box-scroll-container">
                                                <div className="subject-list-box">
                                                    <div className="tip-title">仅限于以下科目使用</div>
                                                    <div className="project-item">{projectName}</div>
                                                    <div className="list-box">
                                                        {userRights.manualCorrectSubjects?.map(item => (
                                                            <div key={item.id} className="subject-item">
                                                                {item.name}
                                                            </div>
                                                        ))}
                                                        {userRights.manualCorrectSubjects?.length % 2 === 1 && (
                                                            <div className="subject-item" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <QuestionCircleOutlined />
                                </span>
                            )}
                            <span className="luca-info-weight">{manualCorrectNum}</span>次
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};

export default memo(Header);
